var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBaChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8337 9.23818V10.0049C18.8326 11.8019 18.2507 13.5504 17.1748 14.9897C16.0988 16.429 14.5864 17.4819 12.8631 17.9914C11.1399 18.501 9.29804 18.4398 7.61238 17.817C5.92673 17.1942 4.48754 16.0433 3.50946 14.5357C2.53138 13.0282 2.06682 11.2449 2.18506 9.45178C2.30329 7.65866 2.998 5.95179 4.16556 4.58575C5.33312 3.2197 6.91098 2.26767 8.66382 1.87164C10.4167 1.47561 12.2505 1.6568 13.892 2.38818M18.8337 3.33341L10.5003 11.6751L8.00033 9.17508",
    stroke: "#087443",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBaChecked);
export default __webpack_public_path__ + "static/media/icon-ba-checked.a2ef3da26915da6700539745663c183d.svg";
export { ForwardRef as ReactComponent };